import { getUserOrg } from './user';
import { AB_TEST_ORG } from './constants';

export const validateAbTest = () => {
  const organization = getUserOrg();
  if (organization) {
    return AB_TEST_ORG.includes(organization);
  }
  return null;
};
